/* eslint-disable import/prefer-default-export */
import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { ArgsGetCompanies } from '~/types/companies';
import {
  getCompanies, getCompany, getCompaniesList, getTop5, createCompany, updateCompany,
} from '~/api/companies';

function useGetCompanies(params: ArgsGetCompanies) {
  return useQuery({
    queryKey: ['companies', params],
    queryFn: () => getCompanies(params),
    keepPreviousData: true,

  });
}

function useGetTop5() {
  return useQuery({
    queryKey: ['top5'],
    queryFn: () => getTop5(),
    refetchInterval: 60000,
  });
}

function useGetCompany(id: string) {
  return useQuery({
    queryKey: ['company', id],
    queryFn: () => getCompany(id),
    enabled: Boolean(id),
    keepPreviousData: true,
  });
}

function useGetCompaniesList(params: { type?: string }) {
  return useQuery({
    queryKey: ['companies-list'],
    queryFn: () => getCompaniesList(params),
    keepPreviousData: true,
  });
}

function useCreateCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { name: string; type: string; exhibitions?: string[] }) => (
      createCompany(payload)
    ),
    onSuccess: async (_data: any, payload) => {
      queryClient.invalidateQueries({ queryKey: ['companies', { type: payload.type }], exact: false });
    },
  });
}

function useUpdateCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: {
      id: string,
      payload: { name: string; exhibitions?: string[] },
    }) => updateCompany(args.id, args.payload),
    onSuccess: async (_data: any, variables) => {
      queryClient.invalidateQueries({ queryKey: ['company', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['companies'], exact: false });
      queryClient.invalidateQueries({ queryKey: ['companies-list'] });
    },
  });
}

export {
  useGetTop5,
  useGetCompanies,
  useGetCompany,
  useGetCompaniesList,
  useCreateCompany,
  useUpdateCompany,
};
